<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/account"></ion-back-button>
    </ion-buttons>
    <ion-title>My Pets</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div class="ion-text-center ion-padding" *ngIf="!isLoading && loadedDogs.length===0">
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-img src="../../../assets/images/MimboLogo.png" class="logo"></ion-img>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-text color="darkmimbo">You have not added any pets yet. <br />
      <br />Press the add button in the bottom right corner to get
      started.</ion-text>
  </div>
  <ion-grid>
    <ion-row>
      <ion-col sizeXl="10" offsetXl="1">
        <ion-list *ngIf="!isLoading && loadedDogs.length>0">
          <ion-item-sliding *ngFor="let dog of loadedDogs">
            <ion-item detail [routerLink]="'addit-dog/' + dog.id" color="lightmimbo"><ion-avatar class="avatar-img">
                <img [src]="dog.imageUrl" />
              </ion-avatar>
              <ion-text class="dog-name">{{dog.name}}<br />
                <ion-text class="dog-breed">{{dog.breed}}</ion-text></ion-text>
            </ion-item>
            <ion-item-options>
              <ion-item-option color="danger" (click)="deleteDog(dog.id)"><ion-icon name="trash-outline"
                  slot="start"></ion-icon>Delete</ion-item-option>
            </ion-item-options>
          </ion-item-sliding>
        </ion-list>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-fab-button><ion-icon name="add-outline" class="add-outline" routerLink="addit-dog"></ion-icon></ion-fab-button>
</ion-content>